<template>
  <div
    :class="[
      $style.marketingBanner,
      gradientBackground && $style.gradientBackground,
      bgImage && $style.backgroundImage,
    ]"
    :style="[{'background-image': bgImage && `url(${bgImage})` }]"
  >
    <b-svg
      v-if="svgTop"
      :name="svgTop"
      :class="[$style.svg, 'b-mb-4']"
      :size="80"
    />

    <div class="b-flex b-mb-3">
      <div class="b-mr-4">
        <div v-if="title" :class="$style.title">
          {{ title }}
        </div>
        <div v-if="description" class="b-font-h6">
          {{ description }}
        </div>
      </div>
      <b-svg
        v-if="svgRight"
        :name="svgRight"
        :class="[$style.svg, 'b-ml-auto']"
        :size="80"
      />
      <img
        v-if="imageRight"
        width="80"
        height="80"
        class="b-ml-auto"
        :src="imageRight"
      />
    </div>

    <slot name="buttons"/>
  </div>
</template>

<script>
export default {
  name: 'b-marketing-banner',

  props: {
    title: {
      type: String,
      default: null,
    },

    description: {
      type: String,
      default: null,
    },

    gradientBackground: {
      type: Boolean,
      default: false,
    },

    bgImage: {
      type: String,
      default: null,
    },

    svgTop: {
      type: String,
      default: null,
    },

    svgRight: {
      type: String,
      default: null,
    },

    imageRight: {
      type: String,
      default: null,
    },
  },
}
</script>

<style lang="scss" module>
.marketingBanner {
  border-radius: 8px;
  padding: 16px;
  background-color: #FFFFFF;

  .title {
    font-weight: 600;
    padding-bottom: 4px;
  }
}

.gradientBackground {
  background: var(--b-gradient-purple)
}

.backgroundImage {
  background-repeat: no-repeat;
  background-position: right top;
}

.svg {
  min-width: 80px;
  max-width: 80px;
}
</style>
